import './lib/validation-config'

// Keep claim ceremony material out of the normal App/tracking module graph.
// This tiny entry executes before dynamically importing any React/auth modules.
import { prepareClaimEntry } from './features/agent-claim/continuation'

if (prepareClaimEntry(window)) {
  void import('./claim-main')
} else {
  void import('./app-main')
}
